/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "service": {
            "nested": {
              "FreezeType": {
                "values": {
                  "FROZEN": 1,
                  "SUSPECTED": 2,
                  "DEBIT_BLOCK": 3,
                  "UNDER_INVESTIGATION": 4,
                  "RISK": 5,
                  "COMPLIANCE": 6,
                  "CIVIL_PROCESS": 7,
                  "RECOVERY_OFFSET": 8,
                  "CREDIT_RISK": 9,
                  "ACTIVATION": 10,
                  "CIVIL_PROCESS_AUTOMATED": 11,
                  "COMPLIANCE_STALE_IDENTITY": 12
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.FreezeType) {
  $root.addJSON(jsonData);
}

/**
 * Type of freeze action. N.B.: used in internal Ledger entities
 *
 * SOURCE FreezeType @ squareup/ledger/freezes.proto at 14:1
 */
export const FreezeType = $root.lookupEnum('squareup.ledger.service.FreezeType').values;